import { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DeferredToasters from "@/components/DeferredToasters";
import { lazyWithRetry } from "@/lib/lazyWithRetry";
import ScrollToTop from "./components/ScrollToTop.tsx";
import CookieNotice from "./components/CookieNotice.tsx";
import EmailClickTracker from "./components/EmailClickTracker.tsx";
// Eagerly load the landing page for fastest first paint
import Index from "./pages/Index.tsx";

// Lazy-load every other route so the initial bundle stays small
const Restrooms = lazyWithRetry(() => import("./pages/Restrooms.tsx"));
const CheckAvailability = lazyWithRetry(() => import("./pages/CheckAvailability.tsx"));
const Events = lazyWithRetry(() => import("./pages/Events.tsx"));
const Blog = lazyWithRetry(() => import("./pages/Blog.tsx"));
const BlogPost = lazyWithRetry(() => import("./pages/BlogPost.tsx"));
const Contact = lazyWithRetry(() => import("./pages/Contact.tsx"));
const Checkout = lazyWithRetry(() => import("./pages/Checkout.tsx"));
const CheckoutReturn = lazyWithRetry(() => import("./pages/CheckoutReturn.tsx"));
const Quote = lazyWithRetry(() => import("./pages/Quote.tsx"));
const Pay = lazyWithRetry(() => import("./pages/Pay.tsx"));
const PrivacyPolicy = lazyWithRetry(() => import("./pages/PrivacyPolicy.tsx"));
const TermsOfService = lazyWithRetry(() => import("./pages/TermsOfService.tsx"));
const AdminLogin = lazyWithRetry(() => import("./pages/AdminLogin.tsx"));
const Admin = lazyWithRetry(() => import("./pages/Admin.tsx"));
const QueryProvider = lazyWithRetry(() => import("./components/QueryProvider.tsx"));
const Unsubscribe = lazyWithRetry(() => import("./pages/Unsubscribe.tsx"));
const NotFound = lazyWithRetry(() => import("./pages/NotFound.tsx"));
const ApiDocs = lazyWithRetry(() => import("./pages/ApiDocs.tsx"));
const OAuthConsent = lazyWithRetry(() => import("./pages/OAuthConsent.tsx"));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="w-8 h-8 rounded-full border-2 border-primary/20 border-t-primary animate-spin" />
  </div>
);

const App = () => (
  <>
      <BrowserRouter>
        <ScrollToTop />
        <EmailClickTracker />
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/restrooms" element={<Restrooms />} />
            <Route path="/check-availability" element={<CheckAvailability />} />
            <Route path="/events" element={<Events />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout" element={<QueryProvider><Checkout /></QueryProvider>} />
            <Route path="/checkout/return" element={<CheckoutReturn />} />
            <Route path="/quote/:id" element={<QueryProvider><Quote /></QueryProvider>} />
            <Route path="/pay/:id" element={<QueryProvider><Pay /></QueryProvider>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/admin/login" element={<QueryProvider><AdminLogin /></QueryProvider>} />
            <Route path="/admin/*" element={<QueryProvider><Admin /></QueryProvider>} />
            <Route path="/unsubscribe" element={<Unsubscribe />} />
            <Route path="/docs/api" element={<ApiDocs />} />
            <Route path="/.lovable/oauth/consent" element={<OAuthConsent />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <CookieNotice />
        <DeferredToasters />
      </BrowserRouter>
  </>
);

export default App;
